import "./trustpilot-rating.js";

class GiftOptions extends HTMLElement {
  connectedCallback() {
    this.innerHTML = /* html */ `
        <div class="production-options mt-3">
            <select
            class="form-select mb-2 js-giftwrap"
            aria-label="Poster giftwrap"
            data-i18n-aria-label="components.giftOptions.giftwrapLabel"
            name="Giftwrap"
            >
            <option value="false" data-price="0" selected data-i18n="components.giftOptions.withoutGiftwrap">
                Zonder cadeauverpakking
            </option>
            <option value="true" id="framed-option" data-price="3.95" data-i18n-price="components.giftOptions.withGiftwrap">
                Met cadeauverpakking + €3,95
            </option>
            </select>
            <select
            class="form-select mb-2 js-giftcard"
            aria-label="Giftcard"
            data-i18n-aria-label="components.giftOptions.giftcardLabel"
            name="Giftcard"
            >
            <option value="false" data-price="0" selected data-i18n="components.giftOptions.withoutCard">
                Zonder kaartje
            </option>
            <option value="true" data-price="1.95" data-i18n-price="components.giftOptions.withCard">
                Met kaartje + €1,95
            </option>
            </select>
            <textarea
            class="form-control js-giftcard-text mb-1"
            rows="4"
            placeholder="Vul hier je persoonlijke boodschap in..."
            data-i18n-placeholder="components.giftOptions.messagePlaceholder"
            style="display: none"
            name="Giftcard text"
            ></textarea>
        </div>
    `;
  }
}

customElements.define("gift-options", GiftOptions);
